import { useNavigate, useParams } from "react-router-dom";
import EmployerEditModal from "../Modals/EmployerEditModal";

/** Deep-link / bookmark entry for employer edit — shows modal and returns on close. */
export default function EmployerEditRoute() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <EmployerEditModal
      employerId={id}
      onClose={() => {
        if (window.history.length > 1) navigate(-1);
        else navigate("/");
      }}
    />
  );
}
